import ky from 'ky';

export async function wpRESTPost(endpoint, data = {}) {
  const uri = window.wpParams.restURL + endpoint;
  const result = await ky
    .post(uri, {
      json: data,
      headers: {
        'X-WP-Nonce': window.wpParams.restNonce,
      },
    })
    .json();
  return result.data;
}

export async function wpRESTGet(endpoint) {
  const uri = window.wpParams.restURL + endpoint;
  return ky
    .get(uri, {
      headers: {
        'X-WP-Nonce': window.wpParams.restNonce,
      },
    })
    .json();
}
